export enum AddressTypeEnum {
  DELIVERY = 'DELIVERY',
  BILLING = 'BILLING',
  COMMERCIAL = 'COMMERCIAL',
}
